import { embedSession } from './embedSession'
import { useBkbnSearchParams } from 'utils/hooks/useBkbnSearchParams'
import { useSyncExternalStore } from 'react'

/**
 * OneSystem channel of the current embed. The broker session is authoritative: `?oneSystem` is
 * client-controlled and is dropped by an in-SPA re-mount, yet it feeds catalogue PRICING, so a
 * param that disagrees with the session prices the order on the wrong channel (ISSUE-2889).
 * The param remains the fallback for a session whose exchange carried no context (rollout).
 */
export const useEmbedIsOneSystem = (): boolean => {
  const params = useBkbnSearchParams()
  const sessionIsOneSystem = useSyncExternalStore(embedSession.subscribe, embedSession.getIsOneSystem)

  return sessionIsOneSystem ?? params.get('oneSystem') === 'true'
}
